<template>
  <div>
    <top-nav></top-nav>
    <div class="center_container">
      <div class="crumb">首页 / 赛事报名 / 赛事详情</div>
      <div class="del_content">
        <div class="del">
          <div class="r_name">{{ details.name }}</div>
          <div class="d_l">
            <img :src="fileUrl + details.imageUrl" alt="">
          </div>
          <div class="d_r">
            <div>
              比赛时间：
              <span style="color: #F26A33">{{ details.gameStartTime + ' 至 ' + details.gameEndTime }}</span>
            </div>
            <div>
              报名时间：
              <span style="color: #1576CD">{{
                  details.applicationStartTime + ' 至 ' + details.applicationEndTime
                }}</span>
            </div>
            <div class="zbf">
              主办方：{{ details.organizer }}
            </div>
          </div>
          <el-button style="width: 164px;" type="primary" @click="toEventRegistration">立即报名</el-button>
        </div>
      </div>
    </div>
    <bot-nav></bot-nav>
  </div>
</template>

<script>
import { FILE_API } from "@/Settings";

export default {
  name: "eventDetails",
  data () {
    return {
      fileUrl: FILE_API,
      activeName: '1',
      details: {}
    }
  },
  created () {
    this.details = JSON.parse(this.$route.query.item)
  },
  methods: {
    toEventRegistration () {
      this.$router.push({
        path: '/eventRegistration',
        query: {
          item: this.$route.query.item
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.center_container {
  .del_content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .del {
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;

    .d_l {
      width: 100%;
      max-height: 500px;

      img {
        width: 100%;
        max-height: 500px;
        //height: 100%;
        object-fit: contain;
      }
    }

    .d_r {
      font-size: 20px;
      margin-top: 40px;
      width: 100%;

      div {
        margin-bottom: 24px;
      }

      .zbf {
        //height: 200px;
        margin-bottom: 86px;
      }
    }
  }

  .r_name {
    font-weight: 700;
    font-size: 36px;
    margin-bottom: 30px;
  }

  .con_main {
    padding: 40px 0 200px;

    .title {
      font-weight: 500;
      font-size: 24px;
      color: #0058A6;
      margin-bottom: 24px;
    }

    .con_font {
      font-size: 18px;
      line-height: 40px;
      margin-bottom: 50px;
    }
  }
}
</style>
